<template>
    <div id="infos">
        <div class="top">
            <!--标题-->
             <div class="head_tit">
                <div class="weather">
                    <div class="weather_tip">{{weather.temp}}&#176;</div>
                    <div class="weather_bolck">
                        <span style="font-family: PINGFANGREGULAR;">{{weather.humidity}}%</span>
                        <span>湿度</span>
                    </div>
                    <div class="weather_bolck">
                        <span style="font-family: PINGFANGREGULAR;">{{weather.tempMin}}&#176;/{{weather.tempMax}}&#176;</span>
                        <span>温度</span>
                    </div>
                    <div class="weather_bolck">
                        <span style="font-family: PINGFANGREGULAR;">{{levelArr[weather.windLevel]}}</span>
                        <span>{{weather.windDir}}</span>
                    </div>
                </div>
                <canvas id="canvas" class="canvas1"></canvas>
                <span class="head_tit_span">{{systemName}}</span>
                <canvas id="canvas2" class="canvas2"></canvas>
                <div class="times">
                    <span class="times_date" style="font-family: PINGFANGREGULAR;">{{lodeTime}}</span>
                    <span class="times_detail" style="font-family: IMPACT;">{{minutesTime}}</span>
                </div>
            </div>
            <!--数值-->
            <div class="head_value">
                <div class="head_value_list">
                    <p class="head_value_list_tit">区域安全指数</p>
                    <div v-if="safedatasShow && timesShow">
                        <animate-number
                                from="0"
                                :to="safedatas"
                                duration="1000"
                                easing="easeOutQuad"
                                id="number1"
                                :key="safedatas"
                        ></animate-number>
                    </div>
                </div>
                <div class="head_value_list">
                    <p class="head_value_list_tit">运维单位数</p>
                    <div v-if="staticsShow && timesShow">
                        <animate-number
                                from="0"
                                :to="depStatistics"
                                duration="1000"
                                easing="easeOutQuad"
                                id="number2"
                                :key="depStatistics"
                        ></animate-number>
                    </div>
                </div>
                <div class="head_value_list">
                    <p class="head_value_list_tit">智能设施数</p>
                    <div v-if="deviceStaticsTotalshow && timesShow">
                        <animate-number
                                from="0"
                                :to="deviceStaticsTotal"
                                duration="1000"
                                easing="easeOutQuad"
                                id="number3"
                                :key="deviceStaticsTotal"
                        ></animate-number>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle">
            <div class="left">
                <div class="left_content">
                    <div class="left_main_first">
                        <div class="left_content_val">
                            <p>当前火警数</p>
                            <div v-if="flamingFireCountshow && timesShow">
                                <animate-number
                                        :from="0"
                                        :to="flamingFireCount"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number4"
                                        :key="flamingFireCount"
                                ></animate-number>
                            </div>
                        </div>
                        <div class="left_content_val">
                            <p>当前预警数</p>
                            <div v-if="warnCountshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="warnCount"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number5"
                                        :key="warnCount"
                                ></animate-number>
                            </div>
                        </div>
                        <div class="left_content_val">
                            <p>智能设施数 (离线)</p>
                            <div v-if="deviceStaticsoffLineshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="deviceStaticsoffLine"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number6"
                                        :key="deviceStaticsoffLine"
                                ></animate-number>
                            </div>
                        </div>
                    </div>

                    <div class="left_main_secend">
                        <div class="left_content_val">
                            <p>当前报警数</p>
                            <div v-if="alarmCountshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="alarmCount"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number7"
                                        :key="alarmCount"
                                ></animate-number>
                            </div>
                        </div>
                        <div class="left_content_val">
                            <p>智能设施数 (在线)</p>
                            <div v-if="deviceStaticsonLineshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="deviceStaticsonLine"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number8"
                                        :key="deviceStaticsonLine"
                                ></animate-number>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="mid">
                <!--闪烁点-->
                <div id="wraps">
                    <div v-for="num in 5" :key="num" :class="'circle-wrap'+num">
                        <div :class="'big-circles'+'  '+'big-circle'+num"></div>
                        <div :class="'bigcircles'+'  '+'bigcircle'+num"></div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="right_content">
                    <div class="right_main_secend">
                        <div class="right_content_val">
                            <p>巡检完成率</p>
                            <div v-if="inspectionRateshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="inspectionRate"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number9"
                                        :key="inspectionRate"
                                ></animate-number>
                                <span style="font-size: 35px">%</span>
                            </div>
                        </div>
                        <div class="right_content_val">
                            <p>培训完成率</p>
                            <div v-if="trainingRateshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="trainingRate"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number10"
                                        :key="trainingRate"
                                ></animate-number>
                                <span style="font-size: 35px">%</span>
                            </div>
                        </div>
                    </div>
                    <div class="right_main_first">
                        <div class="right_content_val">
                            <p>当前隐患数</p>
                            <div v-if="hiddleNumshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="hiddleNum"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number11"
                                        :key="hiddleNum"
                                ></animate-number>
                            </div>
                        </div>
                        <div class="right_content_val">
                            <p>隐患排查率</p>
                            <div v-if="hiddenDangerRateshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="hiddenDangerRate"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number12"
                                        :key="hiddenDangerRate"
                                ></animate-number>
                                <span style="font-size: 35px">%</span>
                            </div>
                        </div>
                        <div class="right_content_val">
                            <p>演练完成率</p>
                            <div v-if="rehearsalRateshow && timesShow">
                                <animate-number
                                        from="0"
                                        :to="rehearsalRate"
                                        duration="1000"
                                        easing="easeOutQuad"
                                        id="number13"
                                        :key="rehearsalRate"
                                ></animate-number>
                                <span style="font-size: 35px">%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--旋转-->
            <div class="area">
                <div id="box" style="transform: perspective(800px) rotateX(5.91625deg) rotateY(-22.2189deg);">
                    <div v-for="count in 8" :key="count" :style="'transform: rotateY('+(0+count*45)+'deg) translateZ(341px);'"></div>
                </div>
            </div>
            <div class="area2">
                <div id="box2" style="transform: perspective(800px) rotateX(-9.5deg) rotateY(0deg);">
                    <div v-for="count in 24" :key="count" :style="'transform: rotateY('+(0+count*15)+'deg) translateZ(280px);'"></div>
                </div>
            </div>

        </div>
        <div class="bottom">
            <div class="bottom_span" @click="submit">
                欢迎登录值守大屏系统
            </div>
        </div>
    </div>
</template>

<script>
    window.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(a){window.setTimeout(a,1E3/60)}}();
    import biaotiImg from '../../assets/images/cockpit/biaoti.png';
    import {right_top1,safezhishu,hj_sum} from '@/assets/js/url.js';
    import Bus from '../../assets/api/Bus'
    import {getDate} from '@/assets/js/index.js';
    export default {
        name: "cockpit",
        data(){
            return{
                levelArr:{
                    1:"一级",
                    2:"二级",
                    3:"三级",
                    4:"四级",
                    5:"五级",
                    6:"六级",
                    7:"七级",
                    8:"八级",
                    9:"九级",
                    10:"十级",
                    11:"十一级",
                    12:"十二级",
                    13:"十三级",
                    14:"十四级",
                    15:"十五级",
                    16:"十六级",
                    17:"十七级",
                    18:"十八级"
                },
                weather:{},
                systemName:'',//标题
                canvas:'',
                canvas2:'',
                biaotiImg,
                timer1:'',
                timer11:'',
                timer2:'',
                timer3:'',
                timer33:'',
                timer4:'',
                timer6:'',
                timer7:'',
                timer8:'',
                enterMain:'',
                lastTime:'',
                loginData:'',
                alarmCount:'0',//当前报警数
                warnCount:'0',//当前预警数
                flamingFireCount:0,//当前火警数
                inspectionRate:0,//巡检完成率
                trainingRate:0,//培训
                hiddleNum:0,//隐患数
                hiddenDangerRate:0,//隐患排查率
                rehearsalRate:0,//演练完成率
                depStatistics:0,//单位数
                safedatas:0,//安全指数
                deviceStaticsTotal:0,
                deviceStaticsonLine:0,
                deviceStaticsoffLine:0,
                lodeTime:'',
                minutesTime:'',
                position:'',
                timesShow:false,
                staticsShow:false,
                safedatasShow:false,
                deviceStaticsTotalshow:false,
                flamingFireCountshow:false,
                warnCountshow:false,
                deviceStaticsoffLineshow:false,
                alarmCountshow:false,
                inspectionRateshow:false,
                trainingRateshow:false,
                hiddleNumshow:false,
                hiddenDangerRateshow:false,
                rehearsalRateshow:false,
                deviceStaticsonLineshow:false,
            }
        },
        created(){
            this.getStatics();
            this.getTopData();
            this.getAllData();
            // this.getHj();
            this.getPatrol();
            this.getTime();
            this.getCrtUrl()
        },
        mounted(){
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
            this.systemName=this.loginData.systemName||'智慧消防物联网值守服务平台';
            this.position=this.loginData.position;
           this.getWeather();
            this.init();
        },
        beforeDestroy () {
            this.clearcavus();
            if(this.timer1){
                clearTimeout(this.timer1);
            }
            if(this.timer2){
                clearTimeout(this.timer2);
            }
            if(this.timer3){
                clearTimeout(this.timer3);
            }
            if(this.timer33){
                clearTimeout(this.timer33);
            }
            if(this.timer4){
                clearTimeout(this.timer4);
            }

            if(this.timer6){
                clearTimeout(this.timer6);
            }
            if(this.timer7){
                clearTimeout(this.timer7);
            }
            if(this.timer8){
                clearTimeout(this.timer8);
            }
            if(this.enterMain){
                clearTimeout(this.enterMain);
            }
            if(this.lastTime){
                clearTimeout(this.lastTime);
            }
        },
        methods:{
            getCrtUrl(){
                let dataObj = {
                    type: 'get',
                    url: '/mcbw/file/template_static',
                    obj: {
                        "fileKey": 'crt_url'
                    }
                }
                this.$Axios(dataObj).then((res)=>{
                    if(res.data.success){
                         window.localStorage.setItem('crt_url', res.data.data||'');
                        
                    }
                })
            },
            getTime() {
                var that = this;
                setInterval(function() {
                    var date = new Date();
                    var year = date.getFullYear(); //获取当前年份
                    var mon = date.getMonth() + 1; //获取当前月份
                    var da = date.getDate(); //获取当前日
                    var h = date.getHours(); //获取小时
                    var m = date.getMinutes(); //获取分钟
                    var s = date.getSeconds(); //获取当前秒数
                    if (da <= 9) {
                        da = "0" + da;
                    }
                    if (h <= 9) {
                        h = "0" + h;
                    }
                    if (mon <= 9) {
                        mon = "0" + mon;
                    }
                    if (m <= 9) {
                        m = "0" + m;
                    }
                    if (s <= 9) {
                        s = "0" + s;
                    }
                    that.lodeTime = year + "-" + mon + "-" + da;
                    that.minutesTime = h + ":" + m + ":" + s;
                }, 1000);
            },
            getWeather(){
                let that=this;
                let dataObj = {
                    type: 'get',
                    url: '/mcbw/moji_weather',
                    obj: {
                        "position": that.position
                    }
                }
                this.$Axios(dataObj).then((res)=>{
                    if(res.data.data.condition){
                        this.weather=res.data.data.condition;
                    }
                }).catch((res)=>{
                });


            },
            getStatics(){
                let dataObj = {
                    type: 'get',
                    url: '/mcbw/homes/details_count',
                    obj: {
                        "type": 4
                    }
                }
                this.$Axios(dataObj).then((res)=>{
                    if(res.data.success){
                        this.deviceStaticsTotal=Number(res.data.data.device.total);
                        this.deviceStaticsonLine=Number(res.data.data.device.onLine);
                        this.deviceStaticsoffLine=Number(res.data.data.device.offLine);
                        this.deviceStaticsTotalshow=true;
                        this.deviceStaticsoffLineshow=true;
                        this.deviceStaticsonLineshow=true;
                    }
                })
            },
            getTopData(){
                let dataObj = {
                    type: 'get',
                    url: right_top1,
                    obj: {
                        "orgId": JSON.parse(window.localStorage.getItem('loginData')).orgId
                    }
                }
                this.$Axios(dataObj).then((res)=>{
                    let total=Number(res.data.data.total);
                    this.depStatistics=total;
                    this.staticsShow=true;
                }).catch(()=>{
                });
            },

            getAllData(){
                const getLeftData = new Promise((resolve, reject)=>{
                    var data = {
                        type: 'get',
                        url: safezhishu,
                        obj: {
                            "monitorId": JSON.parse(window.localStorage.getItem('loginData')).orgId,
                            "dataType":'yesterday',
                            "areaSid":'',
                            "industryCategory":''
                        }
                    };
                    this.$Axios(data).then((res)=>{
                        console.log("zuoshang3434532546",res.data.data)
                        resolve(res.data.data);
                    });
                });
                var data2 = {
                    type: 'get',
                    url: hj_sum,
                    obj: {
                        "orgId": JSON.parse(window.localStorage.getItem('loginData')).orgId,
                    }
                };
                const getHjData = new Promise((resolve, reject)=>{
                    this.$Axios(data2).then((res)=>{
                        resolve(res.data.data);
                    });
                });
                //合并请求接口
                Promise.all([getLeftData, getHjData]).then((res)=>{
                    console.log(res);
                    console.log('top--数据');
                    if(res[0] && res[0]!=''){
                        var safedatas=Number(JSON.parse(res[0]).score);
                        this.safedatas=safedatas;
                    }
                    this.safedatasShow=true;


                    this.flamingFireCount=Number(Math.abs(res[1].flamingFireCount)) || 0;
                    this.alarmCount=Number(Math.abs(res[1].alarmCount)) || 0;
                    this.warnCount=Number(Math.abs(res[1].warnCount)) || 0;
                    this.flamingFireCountshow=true;
                    this.warnCountshow=true;
                    this.alarmCountshow=true;

                    Bus.$emit("topDate", res)
                });
            },
            // getAllData(){
            //     new Promise((resolve, reject)=>{
            //         var data = {
            //             type: 'get',
            //             url: safezhishu,
            //             obj: {
            //                 "monitorId": JSON.parse(window.localStorage.getItem('loginData')).orgId,
            //                 "dataType":'yesterday',
            //                 "areaSid":'',
            //                 "industryCategory":''
            //             }
            //         };
            //         this.$Axios(data).then((res)=>{
            //             if(res.data.data){
            //                 var safedatas=Number(JSON.parse(res.data.data).score);
            //                 this.safedatas=safedatas;
            //                 this.safedatasShow=true;
            //                 window.localStorage.setItem('safedatas', safedatas); //本地保存头部数据信息
            //             }
            //             resolve(res.data.data);
            //         });
            //     });
            // },
            getHj(){
                var data2 = {
                    type: 'get',
                    url: hj_sum,
                    obj: {
                        "orgId": JSON.parse(window.localStorage.getItem('loginData')).orgId,
                    }
                };
                new Promise((resolve, reject)=>{
                    this.$Axios(data2).then((res)=>{
                        this.flamingFireCount=Number(Math.abs(res.data.data.flamingFireCount)) || 0;
                        this.alarmCount=Number(Math.abs(res.data.data.alarmCount)) || 0;
                        this.warnCount=Number(Math.abs(res.data.data.warnCount)) || 0;
                        this.flamingFireCountshow=true;
                        this.warnCountshow=true;
                        this.alarmCountshow=true;
                        let item={
                            flamingFireCount:this.flamingFireCount,
                            alarmCount:this.alarmCount,
                            warnCount:this.warnCount
                        }
                        window.localStorage.setItem('hby', JSON.stringify(item)); //本地保存头部数据信息

                        Bus.$emit("hby", JSON.stringify(item))
                        resolve();
                    });
                });
            },
            getPatrol(){
                let dateType = '';
                switch (this.$store.state.headDate.index){
                    case 0: //日
                        dateType = 'thisDay';
                        break;
                    case 1: //周
                        dateType = 'thisWeek';
                        break;
                    case 2: //月
                        dateType = 'thisMonth';
                        break;
                }
                let dataObj = {
                    type: 'get',
                    url: '/mcbw/patrol_stats/patrol',
                    obj: {
                        "type": dateType,
                        "orgId": JSON.parse(window.localStorage.getItem('loginData')).orgId
                    }
                }
                this.$Axios(dataObj).then((res)=>{
                    let botDataArr=[];
                    botDataArr[0] = this.rightBotReturn(res.data.data.inspectionRate);
                    botDataArr[1] = this.rightBotReturn(res.data.data.hiddenDangerRate);
                    botDataArr[2] = [res.data.data.hiddenDangerCount, 100, 0];
                    botDataArr[3] = this.rightBotReturn(res.data.data.trainingRate);
                    botDataArr[4] = this.rightBotReturn(res.data.data.rehearsalRate);
                    this.inspectionRate=parseFloat(botDataArr[0][0])||0;//巡检完成率
                    this.trainingRate=parseFloat(botDataArr[3][0])||0;//培训
                    this.hiddleNum=parseFloat(botDataArr[2][0])||0;//隐患数
                    this.hiddenDangerRate=parseFloat(botDataArr[1][0])||0;//隐患排查率
                    this.rehearsalRate=parseFloat(botDataArr[4][0])||0;//演练完成率*/


                    this.inspectionRateshow=true;
                    this.trainingRateshow=true;
                    this.hiddleNumshow=true;
                    this.hiddenDangerRateshow=true;
                    this.rehearsalRateshow=true;
                }).catch((res)=>{
                });
            },
            rightBotReturn(data){
                let arr = [];
                if(data == '~'){
                    arr = ['100%', 100, 0];
                }else{
                    arr[0] = Math.round(data.replace('%','')) + '%';  //四舍五入

                    if(Math.round(data.replace('%','')) >= 100){
                        arr[1] = 100;
                        arr[2] = 0;
                    }else{
                        arr[1] = Math.round(data.replace('%',''));
                        arr[2] = 100 - arr[1];
                    }

                }
                return arr;
            },
            init(){
                this.staticsShow=false;
                this.safedatasShow=false;
                this.deviceStaticsTotalshow=false;
                this.flamingFireCountshow=false;
                this.warnCountshow=false;
                this.deviceStaticsoffLineshow=false;
                this.alarmCountshow=false;
                this.timesShow=false;
                this.inspectionRateshow=false;
                this.trainingRateshow=false;
                this.hiddleNumshow=false;
                this.hiddenDangerRateshow=false;
                this.rehearsalRateshow=false;
                this.deviceStaticsonLineshow=false;
                this.selectTime1();
                this.selectTime2();
                this.selectTime3();
                this.selectTime33();
                this.selectTime4();
                this.selectTime6();
                this.selectTime7();
                this.selectTime8();
            },
            //头部标题降落
            selectTime1() {
                var timer1=this.timer1;
                clearTimeout(timer1);//清除上一个定时器
                timer1=setTimeout(function() {
                    $(".head_tit")[0].style.height='56px';
                    $(".head_tit")[0].style.transition='height 1.8s';
                    $(".head_tit_span")[0].style.height='50px';
                    $(".head_tit_span")[0].style.transition='height 1.8s';
                    $(".head_tit")[0].style.marginTop='18px';

                    $(".weather")[0].style.opacity='1';
                    $(".weather")[0].style.transition='opacity 3s';

                    $(".times")[0].style.opacity='1';
                    $(".times")[0].style.transition='opacity 3s';

                },1000);
            },
            //左右框移入
            selectTime2() {
                var timer2=this.timer2;
                clearTimeout(timer2);//清除上一个定时器
                timer2=setTimeout(function() {
                    $(".left")[0].style.width='50%';
                    $(".right")[0].style.width='50%';
                    $(".left")[0].style.transition='width 2s';
                    $(".right")[0].style.transition='width 2s';
                    $(".mid")[0].style.display='block';
                },1800);
            },
            //出现地图
            selectTime3() {
                var timer3=this.timer3;
                clearTimeout(timer3);//清除上一个定时器
                timer3=setTimeout(function() {
                    $(".mid")[0].style.display='block';
                    $(".mid")[0].style.transition='display 3s';
                },2800);
            },
            //出现地图
            selectTime33() {
                let that=this;
                var timer33=this.timer33;
                clearTimeout(timer33);//清除上一个定时器
                timer33=setTimeout(function() {
                    that.loader1();
                    that.loader2();
                },3000);
            },
            //左右框数据显示
            selectTime4() {
                let that=this;
                var timer4=this.timer4;
                clearTimeout(timer4);//清除上一个定时器
                timer4=setTimeout(function() {
                    $(".head_value")[0].style.display='flex';
                    $(".head_value")[0].style.transition='display 0s';
                    var  alist = document.getElementsByClassName( "left_content_val" );
                    if (alist){
                        for (var  idx = 0; idx < alist.length; idx ++){
                            alist[idx].style.visibility = "visible";
                            alist[idx].style.transition='visibility 0s';
                        }
                    }
                    var  alist2 = document.getElementsByClassName( "right_content_val" );
                    if (alist2){
                        for (var  idx2 = 0; idx2 < alist2.length; idx2 ++){
                            alist2[idx2].style.visibility = "visible";
                            alist2[idx2].style.transition='visibility 0s';
                        }
                    }
                    that.timesShow=true;
                },3500);
            },
            //旋转亮灯
            selectTime6() {
                var timer6=this.timer6;
                clearTimeout(timer6);//清除上一个定时器
                timer6=setTimeout(function() {
                    $(".area")[0].style.display='block';
                    $(".area")[0].style.transition='block 2s';
                    $(".area2")[0].style.display='block';
                    $(".area2")[0].style.transition='block 2s';
                    //1.获取元素
                    const oWrap = document.getElementById('box');
                    // 定义一个开始的度数
                    let roY = 0;
                    setInterval(function(){
                        roY-=1;
                        oWrap.style.transform='perspective(800px) rotateY('+roY+'deg)';
                    },30)

                    //2.获取元素
                    const oWrap2 = document.getElementById('box2');
                    // 定义一个开始的度数
                    let roYs = 0;
                    setInterval(function(){
                        roYs+=1;
                        oWrap2.style.transform='perspective(800px) rotateY('+roYs+'deg)';
                    },30)

                },5000);
            },
            //闪烁点
            selectTime7(){
                var timer7=this.timer7;
                clearTimeout(timer7);//清除上一个定时器
                timer7=setTimeout(function() {
                    $("#wraps")[0].style.display='block';
                    $("#wraps")[0].style.transition='display 2s';
                },6500);
            },
            //登录按钮下往上移动
            selectTime8() {
                var timer8=this.timer8;
                clearTimeout(timer8);//清除上一个定时器
                timer8=setTimeout(function() {
                    $(".bottom")[0].style.height='57px';
                    $(".bottom_span")[0].style.height='57px';
                    $(".bottom_span")[0].style.transition='height 1s';
                    $(".bottom")[0].style.transition='height 1s';
                },7500);
            },
            //头部左右两侧动画
            loader1(){
                var canvas = document.getElementById( 'canvas' ),
                    ctx = canvas.getContext( '2d' ),
                    cw = canvas.width = window.innerWidth,
                    ch = canvas.height = 200,
                    twoPi = Math.PI * 2,
                    tick = 0,
                    ot = Date.now(),
                    dt = 1,
                    fps = 1000 / 60,
                    count = cw / 50,
                    spacing = cw / count,
                    circles = [];

                canvas.style.marginTop = -ch / 2 + 'px';
                ctx.fillStyle = '#47CBE7';
                document.body.appendChild( canvas );

                function Circle( opt ) {
                    for( var key in opt ) {
                        this[ key ] = opt[ key ];
                    }
                }

                Circle.prototype.update = function() {
                    this.x = this.xBase + Math.sin( ( tick + this.tickOffset ) / this.tickDiv ) * this.xRange;
                    this.y = this.yBase + Math.sin( ( tick + this.tickOffset ) / this.tickDiv ) * this.yRange;
                    this.radius = this.radiusBase + Math.cos( ( tick + this.tickOffset  ) / this.tickDiv ) * this.radiusRange;
                };

                function loop() {
                    requestAnimFrame( loop )
                    var now = Date.now(),
                        dt = ( now - ot ) / fps;
                    ot = now ;
                    tick += dt;
                    ctx.clearRect( 0, 0, cw, ch );
                    var i = circles.length;
                    ctx.beginPath();
                    while( i-- ){
                        var circle = circles[ i ];
                        circle.update();
                        ctx.moveTo( circle.x, circle.y )
                        ctx.arc( circle.x, circle.y, circle.radius, 0, twoPi );
                    }
                    ctx.fill();
                }

                for( var i = 0; i < count; i++ ){
                    circles.push( new Circle( {
                        xBase: ( cw / 2 ) + ( i * spacing ) - ( ( ( count - 1 ) * spacing ) / 2 ),
                        xRange: 0,
                        yBase: ch / 2,
                        yRange: 75,
                        radiusBase: 10,
                        radiusRange: 10,
                        tickDiv: 15,
                        tickOffset: i * 10
                    } ) );
                }

                for( var i = 0; i < count; i++ ){
                    circles.push( new Circle( {
                        xBase: ( cw / 2 ) + ( i * spacing ) - ( ( ( count - 1 ) * spacing ) / 2 ),
                        xRange: 20,
                        yBase: ch / 2,
                        yRange: 0,
                        radiusBase: 3,
                        radiusRange: 3,
                        tickDiv: 15,
                        tickOffset: i * 10
                    } ) );
                }

                loop();
            },
            loader2(){
                var canvas = document.getElementById( 'canvas2' ),
                    ctx = canvas.getContext( '2d' ),
                    cw = canvas.width = window.innerWidth,
                    ch = canvas.height = 200,
                    twoPi = Math.PI * 2,
                    tick = 0,
                    ot = Date.now(),
                    dt = 1,
                    fps = 1000 / 60,
                    count = cw / 50,
                    spacing = cw / count,
                    circles = [];

                canvas.style.marginTop = -ch / 2 + 'px';
                ctx.fillStyle = '#47CBE7';
                document.body.appendChild( canvas );

                function Circle( opt ) {
                    for( var key in opt ) {
                        this[ key ] = opt[ key ];
                    }
                }

                Circle.prototype.update = function() {
                    this.x = this.xBase + Math.sin( ( tick + this.tickOffset ) / this.tickDiv ) * this.xRange;
                    this.y = this.yBase + Math.sin( ( tick + this.tickOffset ) / this.tickDiv ) * this.yRange;
                    this.radius = this.radiusBase + Math.cos( ( tick + this.tickOffset  ) / this.tickDiv ) * this.radiusRange;
                };

                function loop() {
                    requestAnimFrame( loop )
                    var now = Date.now(),
                        dt = ( now - ot ) / fps;
                    ot = now ;
                    tick += dt;
                    ctx.clearRect( 0, 0, cw, ch );
                    var i = circles.length;
                    ctx.beginPath();
                    while( i-- ){
                        var circle = circles[ i ];
                        circle.update();
                        ctx.moveTo( circle.x, circle.y )
                        ctx.arc( circle.x, circle.y, circle.radius, 0, twoPi );
                    }
                    ctx.fill();
                }

                for( var i = 0; i < count; i++ ){
                    circles.push( new Circle( {
                        xBase: ( cw / 2 ) + ( i * spacing ) - ( ( ( count - 1 ) * spacing ) / 2 ),
                        xRange: 0,
                        yBase: ch / 2,
                        yRange: 75,
                        radiusBase: 10,
                        radiusRange: 10,
                        tickDiv: 15,
                        tickOffset: i * 10
                    } ) );
                }

                for( var i = 0; i < count; i++ ){
                    circles.push( new Circle( {
                        xBase: ( cw / 2 ) + ( i * spacing ) - ( ( ( count - 1 ) * spacing ) / 2 ),
                        xRange: 20,
                        yBase: ch / 2,
                        yRange: 0,
                        radiusBase: 3,
                        radiusRange: 3,
                        tickDiv: 15,
                        tickOffset: i * 10
                    } ) );
                }

                loop();
            },
            clearcavus(){
                var canvas  = document.getElementById("canvas");
                var canvas2  = document.getElementById("canvas2");
                if(canvas){
                    canvas.remove();
                }
                if(canvas2){
                    canvas2.remove();
                }
            },
            //进入主页面动画效果
            enterMains(){
                var enterMain=this.enterMain;
                clearTimeout(enterMain);//清除上一个定时器
                enterMain=setTimeout(function() {
                    $(".bottom")[0].style.display='none';
                    if(document.getElementById("canvas")){
                        var canvas  = document.getElementById("canvas");
                        canvas.remove();
                    }
                    if(document.getElementById("canvas2")){
                        var canvas2  = document.getElementById("canvas2");
                        canvas2.remove();
                    }
                    $(".head_tit")[0].style.marginTop='0px';
                    $(".head_tit")[0].style.height='0px';
                    $(".head_tit")[0].style.transition='height 0.5s ,marginTop 0.5s';
                    $(".head_tit_span")[0].style.height='0px';
                    $(".head_tit_span")[0].style.transition='height 0.5s';
                    $(".left")[0].style.width='0%';
                    $(".right")[0].style.width='0%';
                    $(".left")[0].style.transition='width 1.5s';
                    $(".right")[0].style.transition='width 1.5s';
                    var  alist = document.getElementsByClassName( "left_content_val" );
                    if (alist){
                        for (var  idx = 0; idx < alist.length; idx ++){
                            alist[idx].style.visibility = "hidden";
                            alist[idx].style.transition='visibility 0s';
                        }
                    }
                    var  alist2 = document.getElementsByClassName( "right_content_val" );
                    if (alist2){
                        for (var  idx2 = 0; idx2 < alist2.length; idx2 ++){
                            alist2[idx2].style.visibility = "hidden";
                            alist2[idx2].style.transition='visibility 0s';
                        }
                    }
                    $(".head_value")[0].style.display='none';

                    this.staticsShow=false;
                    this.safedatasShow=false;
                    this.deviceStaticsTotalshow=false;
                    this.flamingFireCountshow=false;
                    this.timesShow=false;
                    this.warnCountshow=false;
                    this.deviceStaticsoffLineshow=false;
                    this.alarmCountshow=false;
                    this.inspectionRateshow=false;
                    this.trainingRateshow=false;
                    this.hiddleNumshow=false;
                    this.hiddenDangerRateshow=false;
                    this.rehearsalRateshow=false;
                    this.deviceStaticsonLineshow=false;

                    $(".area")[0].style.display='none';
                    $(".area2")[0].style.display='none';
                    $(".head_value")[0].style.transition='display 0s';
                    $(".area")[0].style.transition='display 0.1s';
                    $(".area2")[0].style.transition='display 0.1s';
                    $(".mid")[0].style.bottom='40%';
                    $(".mid")[0].style.height='162.5px';
                    $(".mid")[0].style.width='212.5px';
                    $(".mid")[0].style.opacity='0.1';
                    $(".mid")[0].style.transition='width 1.5s ,height 1.5s ,bottom 1.5s ,opacity 1.5s';
                    $("#wraps")[0].style.display='none';
                    $("#wraps")[0].style.transition='display 0.1s';
                    $("#infos")[0].style.opacity='0';
                    $("#infos")[0].style.transition='opacity 1.5s';
                },100);
            },
            lastTimes(){
                let that=this;
                var lastTime=this.lastTime;
                clearTimeout(lastTime);//清除上一个定时器
                lastTime=setTimeout(function() {
                    that.$emit("mainIndex")
                },1600);
            },
            submit(){
                this.enterMains();
                this.lastTimes();
                
            }
        }
    }
</script>

<style scoped>
    .weather{
        position: absolute;
        left: 4%;
        top: 3%;
        display: flex;
        flex-direction: row;
        opacity:0;
        font-family: IMPACT;
    }
    .weather_tip{
        font-size: 41px;
        color: #c9deec;
        margin-right: 18px;
        line-height: 64px;
        height: 50px;
    }
    .weather_bolck{
        display: flex;
        flex-direction: column;
        margin-right: 8px;
    }
    .weather_bolck span{
        font-size: 16px;
        font-weight: 450;
        line-height: 26px;
        height: 26px;
        color: #c9deec;
        font-family: Microsoft YaHei;
    }
    .times{
        position: absolute;
        right: 4%;
        top: 3%;
        display: flex;
        flex-direction: row;
        opacity:0;
    }
    .times_date{
        color: #c9deec;
        font-size: 18px;
        line-height: 68px;
        padding-right: 6px;
    }
    .times_detail{
        color: #c9deec;
        font-size: 35px;
    }
    .canvas1{
        display: block;
        left: 16%;
        position: absolute;
        top: 4%;
        width: 400px;
        height: 20px;
        margin-top: 0px !important;
        z-index: 900;
    }
    .canvas2{
        display: block;
        right: 16%;
        position: absolute;
        top: 4%;
        width: 400px;
        height: 20px;
        margin-top: 0px !important;
        z-index: 900;
    }
    #infos{
        width: 100%;
        height: 100%;
        background-image: url("../../assets/images/cockpit/bgs.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        opacity: 1;
    }
    /*  头部文字*/
    .top{
        width: 100%;
        text-align: center;
    }
    .head_tit{
        display: inline-block;
        background-image: url("../../assets/images/cockpit/title.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 40%;
        height: 0px;
        line-height: 56px;
        font-size: 23px;
        color: #ffffff;
        z-index: 2;
        vertical-align: top;
        font-weight: bold;
    }
    .head_tit_span{
        display: inline-block;
        height: 0px;
        background-image: linear-gradient(to bottom,#ffffff,#7db4db);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 35px;
    }

    /*  中间部分*/
    .middle{
        z-index: 1;
        display: flex;
        flex-flow: row;
        justify-content: center;
        width: 100%;
    }
    .left{
        background-image: url("../../assets/images/cockpit/left.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 0%;
        position: absolute;
        left: 0;
        height: 867px;
        bottom: 0%;
    }
    .left_content{
        position: absolute;
        top: 13%;
        left: 5%;
        justify-content: center;
        align-items: center;
        display: flex;
    }
    .left_main_first{
        display: flex;
        flex-direction: column;
        height: 620px;
        justify-content: space-between;
        margin-right: 60px;
    }
    .left_main_secend{
        display: flex;
        flex-direction: column;
        height:320px;
        justify-content: space-between;
    }
    .left_content_val{
        min-width: 180px;
        font-size: 20px;
        visibility: hidden;
    }
    .left_content_val p{
        font-family: Alibaba-PuHuiTi-Medium;
        font-size: 22px;
        color: #e4eff5;
    }
    .left_content_val span{
        font-size: 35px;
        font-family: youzhihei;
        background-image: linear-gradient(to bottom,#ffffff,#7db4db);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .right{
        background-image: url("../../assets/images/cockpit/right.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 0%;
        position: absolute;
        right: 0;
        height: 867px;
        bottom: 0%;
    }
    .right_content{
        position: absolute;
        top: 13%;
        right: 5%;
        justify-content: center;
        align-items: center;
        display: flex;
    }
    .right_main_first{
        display: flex;
        flex-direction: column;
        height: 620px;
        justify-content: space-between;
        margin-left: 60px;
    }
    .right_main_secend{
        display: flex;
        flex-direction: column;
        height:320px;
        justify-content: space-between;
    }
    .right_content_val{
        min-width: 180px;
        font-size: 20px;
        visibility: hidden;
    }
    .right_content_val p{
        font-family: Alibaba-PuHuiTi-Medium;
        font-size: 22px;
        color: #e4eff5;
    }
    .right_content_val span{
        font-size: 35px;
        font-family: youzhihei;
        background-image: linear-gradient(to bottom,#ffffff,#7db4db);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .mid{
        background-image: url("../../assets/images/cockpit/ditu.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 650px;
        width: 850px;
        z-index: 2;
        bottom: 15.5%;
        position: absolute;
        display: none;
    }
    /* 转盘动画 */
    .area{
        left: 49.35%;
        bottom: -27.5%;
        position:fixed;
        display: none;
    }
    #box{
        width:60px;
        height: 346px;
        margin: 100px auto;
        position:relative;
        transform-style: preserve-3d;
    }
    #box div{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 1%;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        box-shadow: 0px 0px 10px 5px #6FD9DD;
        background:-webkit-gradient(linear, 0% 0%, 0% 100%, from(#5df7e5), to(#0FC7DD));
    }
    .area2{
        left: 49.2%;
        bottom: -23%;
        position:fixed;
        display: none;
    }
    #box2{
        width:33px;
        height: 331px;
        margin: 100px auto;
        position:relative;
        transform-style: preserve-3d;
    }
    #box2 div{
        position: absolute;
        top:0;
        left: 0;
        width: 20%;
        height: 0.1%;
        border-radius: 2px;
        background-color: #53C5F0;
    }

    /*地图闪烁点*/
    #wraps{
        position: absolute;
        top: 29%;
        left: 15%;
        display: none;
    }
    .circle-wrap1 {
        position: absolute;
        left: 97px;
        top: 159px;
    }
    .circle-wrap2 {
        position: absolute;
        left: 190px;
        top: 100px;
    }
    .circle-wrap3 {
        position: absolute;
        left: 300px;
        top: 100px;
    }
    .circle-wrap4 {
        position: absolute;
        left: 260px;
        top: 176px;
    }
    .circle-wrap5 {
        position: absolute;
        left: 508px;
        top: 56px;
    }

    .big-circles{
        position: absolute;
        top: -2px;
        left: -2px;
        width: 85%;
        height: 85%;
        border-radius: 50%;
        background: #06376E;
        box-shadow: #5feaf7 0px 0px 5px inset;
        animation-fill-mode: both;
    }
    .big-circle1 {
        animation: bigling 2s infinite ease-in-out;
    }
    .big-circle2 {
        animation: bigling 3s infinite ease-in-out;
    }
    .big-circle3{
        animation: bigling 4s infinite ease-in-out;
    }
    .big-circle4{
        animation: bigling 1s infinite ease-in-out;
    }
    .big-circle5{
        animation: bigling 5s infinite ease-in-out;
    }
    @keyframes bigling {
        0% {
            opacity: 0.2;
            transform: scale(1);
        }
        50% {
            opacity: 0.5;
            transform: scale(1.3);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    }
    .bigcircles{
        position: absolute;
        width: 12px;
        height: 12px;
        top: -2px;
        left: -2px;
        border-radius: 50%;
        opacity: 0.8;
        background-color: #5feaf7;
        box-shadow: #ffffff 0px 0px 5px inset;
    }
    .bigcircle1 {
        animation: scales 2s infinite cubic-bezier(0, 0, .49, 1.02);
    }
    .bigcircle2 {
        animation: scales 3s infinite cubic-bezier(0, 0, .49, 1.02);
    }
    .bigcircle3 {
        animation: scales 4s infinite cubic-bezier(0, 0, .49, 1.02);
    }
    .bigcircle4{
        animation: scales 1s infinite cubic-bezier(0, 0, .49, 1.02);
    }
    .bigcircle5{
        animation: scales 5s infinite cubic-bezier(0, 0, .49, 1.02);
    }
    @keyframes scales {
        0% {
            transform: scale(1)
        }

        50%,
        75% {
            transform: scale(3)
        }

        78%,
        100% {
            opacity: 0
        }
    }

    /*底部登录按钮*/
    .bottom{
        text-align: center;
        position: fixed;
        bottom: 8px;
        height: 0px;
        width: 100%;
    }
    .bottom_span{
        color: #ffffff;
        font-size: 24px;
        font-family: "Microsoft YaHei";
        font-weight: 600;
        font-style: italic;
        line-height: 57px;
        height: 0px;
        width: 22%;
        background-image: url("../../assets/images/cockpit/biaoti.png");
        background-repeat: no-repeat;
        background-position: center;
        display: inline-block;
        background-size: 100% 100%;
        z-index: 2;
    }

    /*  动态数值*/
    .head_value{
        justify-content: center;
        top:30px;
        height: 150px;
        align-items: center;
        display: none;
    }
    .head_value_list{
        width: 260px;
        height: 108px;
        text-align: center;
    }
    .head_value_list_tit{
        font-family: PingFang-SC-Semibold;
        font-size: 23px;
        color: #ffffff;
        font-weight: 400;
    }
    .head_value_list span{
        font-size: 50px;
        font-family: youzhihei;
        background-image: linear-gradient(to bottom,#ffffff,#7db4db);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
</style>



// WEBPACK FOOTER //
// src/pages/index/cockpit.vue